import { HStack, Box, Center } from '@chakra-ui/react'
import { RoundedButton } from '../../GameCompsF.jsx'

export const ThreeColPill = (/** @type {{leftContent?: import('react').ReactNode, children?: import('react').ReactNode, rightContent?: import('react').ReactNode, [key: string]: any}} */ {leftContent, children, rightContent, ...props}) => {
  return <RoundedButton {...{...props}}>
    <HStack {...{justifyContent: 'space-evenly'}}>
      <Box {...{flex: 1, fontSize: '3xl'}}>
        {leftContent}
      </Box>
      <Box {...{flex: 1}}>{children}</Box>
      <Center {...{flex: 1}}>{rightContent}</Center>
    </HStack>
  </RoundedButton>
}